<template>
  <div
    class="container-fluid"
    v-if="auth == 'loggedin' || token != null || token != undefined"
  >
  <!-- <b-row>
    <b-button
      size="sm"
      variant="primary"
      class="btn float-left"
      @click="excelImport"
      ><b-icon-plus-circle></b-icon-plus-circle>
      EXCEL IMPORT
    </b-button>
  </b-row> -->

    <b-card
      border-variant="secondary"
      class="text-center mt-5"
    >
      <div class="col-sm-12">
        <h1 class="h1cimke">Készletlista</h1>
        <div class="row">

          <div v-if="userType=='admin' || userType=='user'" class="col-sm-4">
            <!-- // NEW -->
            <b-button
              size="sm"
              variant="primary"
              class="btn float-left"
              @click="$router.push({ name: 'CikkekNew' })"
              ><b-icon-plus-circle></b-icon-plus-circle>
              Új cikk hozzáadása
            </b-button>
          </div>

          <!-- // SEARCH INPUT -->
          <div>
            <b-button-group>
              <b-button
                size="sm"
                class="btn float-left"
                variant="outline-danger"
                @click="searchText='', filterSelect='', search()"
                ><b-icon-x-circle></b-icon-x-circle>
              </b-button>

              <b-form-select
                size="sm"
                v-model="filterSelect"
                :options="filters"
                class="form-control"
                id="td"
                required
              ></b-form-select>
            </b-button-group>
          </div>

          <div class="col-sm-2">
            <b-form-input
              size="sm"
              class="form-control"
              ref="searchInput"
              v-model="searchText"
              id="search"
              @click="searchText=''"
              @keyup.enter="search()"
              autofocus
            ></b-form-input>
          </div>

          <div>
            <b-button
              size="sm"
              class="btn float-left"
              variant="success"
              @click="search()"
              ><b-icon-search></b-icon-search>
              Keresés
            </b-button>
          </div>

          <div>
            <b-button
              size="sm"
              class="btn float-right showbtn"
              variant="outline-primary"
              @click="showNetto()"
              ><b-icon-eye></b-icon-eye>
            </b-button>
          </div>

        </div>

      </div>

      <!-- // TABLE -->
      <div class="mt-3">
        <b-table class="labelsize table-striped" hover :items="list" :fields="fields" :key="list.id">

          <!-- // EDIT -->
          <template v-if="userType=='admin' || userType=='user'" v-slot:cell(edit)="row">
            <b-button v-if="row.item.closed != 1"
              size="sm"
              @click="
                $router.push({
                  name: 'CikkekNew',
                  params: { id: row.item.id }
                })
              "
              variant="outline-success"
              class="mr-0"
            ><b-icon-pencil></b-icon-pencil>
            </b-button>
          </template>

          <!-- // NETTÓ BESZÁR -->
          <template v-slot:cell(nettobeszar)="row" class="mb-1">
            <p v-show="beszArShow=='1'">{{row.item.nettobeszar}}</p>
          </template>

          <!-- // DELETE -->
          <template v-slot:cell(del)="row" class="mb-1">
            <b-button
              size="sm"
              @click="showMsgBoxTwo(row.item.id)"
              variant="outline-danger"
              class="mr-1"
              ><b-icon-trash></b-icon-trash>
            </b-button>
          </template>
        </b-table>
      </div>
    </b-card>
  </div>
</template>

<script>
import axios from 'axios'
import router from '../router'
import VueHtml2pdf from 'vue-html2pdf'
import jwtDecode from 'jwt-decode'
import moment from 'moment'

export default {
  components: {
    VueHtml2pdf
  },
  data () {
    const token = localStorage.usertoken
    const decoded = jwtDecode(token)
    return {
      dateconvert: null,
      EgyebTetelekShow: false,
      tableHeadShow: false,
      boxTwo: '',
      token: localStorage.usertoken,
      auth: '',
      userType: decoded.usertype,
      filters: [
        'Minden oszlop',
        'Megnevezés'
      ],
      list: [],
      fields: [
        // {
        //   key: 'id',
        //   label: 'Id',
        //   sortable: true
        //   // sortDirection: 'asc'
        // },
        // {
        //   key: 'emaillink',
        //   label: 'CRM',
        //   sortable: true,
        //   sortDirection: 'desc',
        //   tdClass: 'text-right',
        //   thClass: 'text-right'
        // },
        {
          key: 'nev',
          label: 'Megnevezés',
          sortable: true,
          thClass: 'text-left',
          tdClass: 'text-left'
        },
        {
          key: 'csikkCsoport',
          label: 'Cikkcsoport',
          sortable: true,
          thClass: 'text-left',
          tdClass: 'text-left'
        },
        {
          key: 'cikkszam',
          label: 'Cikkszám',
          sortable: true,
          thClass: 'text-left',
          tdClass: 'text-left'
        },
        {
          key: 'vonalkod',
          label: 'Vonalkód',
          sortable: true,
          thClass: 'text-left',
          tdClass: 'text-left'
        },
        {
          key: 'gyarto',
          label: 'Gyártó',
          sortable: true,
          thClass: 'text-left',
          tdClass: 'text-left'
        },
        {
          key: 'mennyisegiegyseg',
          label: 'egys.',
          sortable: true,
          thClass: 'text-left'
        },
        {
          key: 'nettobeszar',
          label: 'Nettó besz.ár',
          sortable: true,
          thClass: 'text-right',
          tdClass: 'text-right'
        },
        {
          key: 'bruttofogyar',
          label: 'Bruttó fogy.ár',
          sortable: true,
          thClass: 'text-right',
          tdClass: 'text-right'
        },
        {
          key: 'mennyiseg',
          label: 'DB',
          sortable: true
          // thClass: 'text-left'
        },
        {
          key: 'keszletertek',
          label: 'Készlet érték',
          sortable: true,
          thClass: 'text-right',
          tdClass: 'text-right'
        },
        { key: 'edit', sortable: false }
        // { key: 'del', sortable: false }
      ],
      myTempAnyagTipus: [],
      searchText: '',
      filterSelect: '',
      beszArShow: 0
    }
  },
  methods: {
    showNetto () {
      console.log('HI')
      if (this.beszArShow === 0) {
        this.beszArShow = 1
      } else {
        this.beszArShow = 0
      }
    },
    excelImport () {
      let payload = {}
      if (!this.token) {
        router.push({ name: 'Login' })
      } else {
        payload.token = this.token
        payload.userType = this.userType
        axios.get('http://' + process.env.ROOT_API + '/cikkek/excelimport', {payload})
          .then(res => {
            console.log(res)
          })
          .catch(err => {
            console.log(err)
          })
      }
    },
    search () {
      let payload = {}
      if (!this.token) {
        router.push({ name: 'Login' })
      } else {
        payload.token = this.token
        payload.userType = this.userType
        payload.filter = this.filterSelect
        payload.searchText = this.searchText
        axios.post('http://' + process.env.ROOT_API + '/cikkek/search', {payload})
          .then(res => {
            this.list = []
            for (var el in res.data) {
              this.list.push({
                id: res.data[el].id,
                nev: res.data[el].nev,
                csikkCsoport: res.data[el].csikkCsoportModel.megnevezes,
                cikkszam: res.data[el].cikkszam,
                vonalkod: res.data[el].vonalkod,
                gyarto: res.data[el].gyartoModel.megnevezes,
                mennyisegiegyseg: res.data[el].mennyisegiegyseg,
                nettobeszar: res.data[el].nettobeszar,
                bruttofogyar: res.data[el].bruttofogyar,
                mennyiseg: res.data[el].mennyiseg,
                keszletertek: res.data[el].bruttofogyar * res.data[el].mennyiseg
              })
            }
            console.log(this.list)
            this.$refs.searchInput.focus()
          })
          .catch(err => {
            console.log(err)
          })
      }
    },
    redirect: function (link, target = '_blank') {
      window.open(link, target)
    },
    printPDF (req) {
      let payload = {}
      if (!this.token) {
        router.push({ name: 'Login' })
      } else {
        payload.token = this.token
        payload.userType = this.userType
        payload.id = req
        axios.post('http://' + process.env.ROOT_API + '/cikkek/pdf', {payload})
          .then(res => {
            this.myTempAnyagTipus = res.data.client
            if (this.myTempAnyagTipus.cikkTetels.length > 0) {
              this.EgyebTetelekShow = true
            } else { this.EgyebTetelekShow = false }
            this.$refs.html2Pdf.generatePdf()
          })
          .catch(err => {
            console.log(err)
          })
      }
    },
    deleteElement: function (req) {
      let payload = {}
      if (!this.token) {
        router.push({ name: 'Login' })
      } else {
        payload.token = this.token
        payload.userType = this.userType
        payload.id = req
        axios
          .post('http://' + process.env.ROOT_API + '/cikkek/delete', { payload })
          .then(res => {
            this.loadList()
          })
          .catch(err => {
            console.log(err)
          })
      }
    },
    showMsgBoxTwo (id, partner) {
      this.boxTwo = ''
      this.$bvModal
        .msgBoxConfirm('(ID:' + id + ') ' + partner, {
          title: 'Biztos törlöni akarod?',
          size: 'sm',
          buttonSize: 'sm',
          okVariant: 'danger',
          okTitle: 'IGEN',
          cancelTitle: 'NEM',
          footerClass: 'p-2',
          hideHeaderClose: false,
          centered: true
        })
        .then(value => {
          if (value) this.deleteElement(id)
        })
        .catch(err => {
          console.log(err)
        })
    },
    loadList () {
      let payload = {}
      if (!this.token) {
        router.push({ name: 'Login' })
      } else {
        payload.token = this.token
        payload.userType = this.userType
        axios.post('http://' + process.env.ROOT_API + '/cikkek/getlist', {payload})
          .then(res => {
            for (var el in res.data) {
              this.list.push({
                id: res.data[el].id,
                nev: res.data[el].nev,
                csikkCsoport: res.data[el].csikkCsoportModel.megnevezes,
                cikkszam: res.data[el].cikkszam,
                vonalkod: res.data[el].vonalkod,
                gyarto: res.data[el].gyartoModel.megnevezes,
                mennyisegiegyseg: res.data[el].mennyisegiegyseg,
                nettobeszar: res.data[el].nettobeszar,
                bruttofogyar: res.data[el].bruttofogyar,
                mennyiseg: res.data[el].mennyiseg,
                keszletertek: res.data[el].bruttofogyar * res.data[el].mennyiseg
              })
            }
          })
          .catch(err => {
            console.log(err)
          })
      }
    }
  },
  mounted: function () {
    this.loadList()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Cikkek.vue